import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';

const selector = (state) => get(state, SCOPE);

export default selector;

export const trendsViewSelector = createSelector(selector, (store) => store.trends);

export const filtersViewSelector = createSelector(selector, (store) => store.filters);

export const nocModeSelector = createSelector(selector, (store) => store.mode);

export const unsavedThresholdSelector = createSelector(
  selector,
  (store) => store.unsavedThresholdChanges,
);

export const allThresholdCellSelectionSelector = createSelector(
  selector,
  (store) => store.allThresholdSelection,
);

export const adminRoleSelector = createSelector(selector, (store) => store.isAdminRole);

export const autoSortEnabledSelector = createSelector(selector, (store) => store.isAutoSortEnabled);

export const redirectedFromNocSelector = createSelector(
  selector,
  (store) => store.isRedirectedFromNocTiles,
);

export const greenBarEnabledSelector = createSelector(selector, (store) => store.isGreenBarEnabled);
